const reloadPage = () => window.location.reload();

export default reloadPage;
